export default "__VITE_ASSET__CusYdZwZ__"